import { observer } from 'mobx-react';
import { fromArrayMaybe } from 'nonempty-list';
import { emptyFragment } from '../../../../../EmptyFragment';
import ParticipantStore from '../../../../../ParticipantStore';
import { T } from '../../../../../Translations';
import LightModeTooltip from '../../../../LightModeTooltip';
import LicenseDetails from './LicenseDetails';

interface Props {
  store: ParticipantStore;
}

function UserLicenses({ store }: Props) {
  return fromArrayMaybe(store.resource.payload.licenses)
    .map((licenses) => (
      <LightModeTooltip
        trigger={
          <span className="underline decoration-dashed decoration-teal-600">{licenses.length}</span>
        }
      >
        <div className="flex flex-col my-3 gap-4">
          <span>
            {store.resource.payload.fullName
              .map((name) => (
                <T
                  kind="Licenses Allocated to <name/>"
                  name={<span className="font-semibold">{name}</span>}
                />
              ))
              .getOrElse(emptyFragment)}
          </span>
          {licenses.toArray().map((license) => (
            <LicenseDetails key={license.payload.id} license={license} />
          ))}
        </div>
      </LightModeTooltip>
    ))
    .getOrElse(() => <>0</>);
}

export default observer(UserLicenses);
